import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Caeser Cipher II",
  url: "caeser-cipher-2",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {String} str
* @param {Number} key
* @return {String}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function caeserCipher(str, key) {
  // your code goes here        
};
`,
};

export default info;
